var map = {
	"./assets/icons.js": [
		94
	],
	"./controls/EmbedButton.js": [
		897,
		9
	],
	"./controls/helpers.js": [
		893,
		10
	],
	"./controls/hlsResolutionMenu.js": [
		894,
		7
	],
	"./controls/mp4ResolutionMenu.js": [
		895,
		8
	],
	"./controls/rewind.js": [
		898,
		11
	],
	"./ima/autoplay.js": [
		901,
		1
	],
	"./ima/videojs.ima.js": [
		295
	],
	"./index.js": [
		49
	],
	"./neouskin.js": [
		899,
		0,
		6
	],
	"./registerVjsComponent.js": [
		896,
		12
	],
	"./screens/Embed.js": [
		214
	],
	"./screens/nextVideoTimer.js": [
		171
	],
	"./screens/rating.js": [
		215
	],
	"./screens/videoWall.js": [
		216
	],
	"./skin.js": [
		900,
		0,
		5
	],
	"./video.js": [
		220
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 673;
module.exports = webpackAsyncContext;